<div class="landing" [style.--landing-accent-color]="config.general?.background_color">
  <app-landing-hero [config]="config"></app-landing-hero>

  <main class="landing-body">
    <section class="landing-section" *ngFor="let section of sections">
      <!-- El nombre de la sección solo se muestra si hay varias -->
      <h2 *ngIf="sections.length > 1">{{ section.name }}</h2>

      <div class="landing-cards">
        <app-landing-compact-card
          *ngFor="let form of section.forms"
          [form]="form"
          variant="white"
          (open)="selectForm.emit(form)"
        ></app-landing-compact-card>
      </div>
    </section>
  </main>
</div>
